<template>
  <div class="file-list">
    <div :class="['item', item == activeItem ? 'active' : '']" v-for="item in folderItems" :key="item.id">
      <template v-if="item.filename == '.'">
        <a href="javascript:void(0)" @click.prevent.stop="activeItem=item; changeFolder(item)" @click.right.prevent="showMenu('folderMenu', $event, item)">
          <img v-if="!item.private" src="../assets/plain-folder.png" alt="folder">
          <img v-else-if="item.private === true && !item.user_has_access" src="../assets/locked-folder.png" alt="folder">
          <img v-else-if="item.private === true && item.user_has_access" src="../assets/unlocked-folder.png" alt="folder">
          {{ item.display_name }}
          <div class="file-date">{{ item.created|fmtdate }}</div>
        </a>
      </template>
      <template v-else>
        <a href="javascript:void(0)" class="file" @click.prevent.stop="activeItem=item; download(item)" @click.right.prevent="showMenu('fileMenu', $event, item)">
          <div class="name">
            <file-icon :filename="item.filename.toLowerCase()" />
            {{ item.display_name }}
          </div>
          <div class="file-date">{{ item.created|fmtdate }}</div>
        </a>
      </template>
    </div>

    <div ref="folderMenu" class="context-menu">
      <a href="javascript:void(0)" @click.stop="showFolderRename">Rename Folder</a>
      <a href="javascript:void(0)" v-if="activeItem.private === true" @click.stop="togglePrivate">Change Access to Public</a>
      <a href="javascript:void(0)" v-else @click.stop="togglePrivate">Change Access to Private</a>
      <a href="javascript:void(0)" @click.stop="showItemMove">Move Folder</a>
      <hr>
      <a href="javascript:void(0)" @click.stop="showConfirmDelete">Delete Folder</a>
    </div>
    <div ref="fileMenu" class="context-menu">
      <a href="javascript:void(0)" @click.stop="showFileRename">Rename File</a>
      <a href="javascript:void(0)" @click.stop="showItemMove">Move File</a>
      <a href="javascript:void(0)" @click.stop="showConfirmDelete">Delete File</a>
    </div>

    <modal ref="renameFolder">
    <h5>Rename Folder</h5>
    <form @submit.prevent="setItemName">
      <p>
      <input autofocus type="text" size="50" v-model="newItem" />
      </p>
      <p>
      <button>Save</button>
      </p>
    </form>
    </modal>
    <modal ref="renameFile">
    <h5>Rename File</h5>
    <form @submit.prevent="setItemName">
      <p>
      <input autofocus type="text" size="50" v-model="newItem" />
      </p>
      <p>
      <button>Save</button>
      </p>
    </form>
    </modal>
    <modal ref="moveItem" class="move-item-dialog">
    <h5>Move Item</h5>
    <p>To: {{ currentMove.display_name }}</p>
    <form class="move-item-form" @submit.prevent="moveItem">
      <div class="move-nav">
        <a href="javascript:void(0)" @click.prevent="changeMoveDir(-1)" v-if="currentMove.path != 'Root'">Back</a>
      </div>
      <div class="move-folder-list">
        <template v-if="moveTargets.length > 0">
          <div class="folder" v-for="folder in moveTargets" :key="folder.id">
            <a href="javascript:void(0)" @dblclick.prevent="changeMoveDir(folder)">
              <i class="fas fa-fw fa-folder" />{{ folder.display_name }}
            </a>
          </div>
        </template>
        <template v-else>
          <p>No subfolders are in this folder.</p>
        </template>
      </div>
      <p>
      <button>Move</button>
      </p>
    </form>
    </modal>
    <modal ref="confirm">
    <h5>Confirm Deletion</h5>
    <p v-if="activeItem.filename == '.'">
    This will remove all files and folders in {{activeItem.display_name}}.
    </p>
    <p>
    Are you sure you want to delete <em>{{activeItem.display_name}}</em>?
    </p>
    <p>
    <button @click.prevent="deleteActiveItem">Yes</button>
    <button class="cancel" @click.prevent="$refs.confirm.close()">No</button>
    </p>
    </modal>
  </div>
</template>

<script>
import axios from 'axios'
import {mapState} from 'vuex'

import Modal from './Modal.vue'
import FileIcon from './FileIcon.vue'

export default {
  name: 'FileList',
  props: ['value'],
  components: {Modal, FileIcon},
  data() {
    return {
      folderItems: [],
      newItem: '',
      activeItem: {},
      lastFolder: null,
      currentMove: {
        path: 'Root',
        id: null,
        folders_only: true,
      },
      moveTargets: [],
      accessPerms: [],
    }
  },
  computed: {
    ...mapState(['user', 'sortMethod']),
    currentFolder() {
      return this.value
    },
  },
  watch: {
    value(newval) {
      this.value = newval
      this.getItems()
    }
  },
  methods: {
    async togglePrivate() {
      let status = !this.activeItem.private

      let r = await axios.put(`/api/files/${this.activeItem.id}`, {
        file: {private: status}
      })
      if (r.status != 200) {
        return
      }

      this.activeItem.private = status
      this.hideMenus()
      this.activeItem = {}
    },
    async deleteActiveItem() {
      let r = await axios.delete(`/api/files/${this.activeItem.id}`)

      if (r.status != 200) {
        return
      }

      this.getItems()
      this.$refs.confirm.close()
    },
    showConfirmDelete() {
      this.$refs.confirm.showModal()
    },
    async moveItem() {
      let parts = this.activeItem.folder.split('.')

      this.activeItem.folder = this.currentMove.path + '.' + parts[parts.length - 1]

      let r = await axios.put(`/api/files/${this.activeItem.id}`, {file: this.activeItem})
      if (r.status != 200) {
        return;
      }

      this.activeItem = {}
      this.getItems()
      this.$refs.moveItem.close()
    },
    async getMoveDir() {
      let r = await axios.get('/api/files/get-items', {params: this.currentMove})            

      if (r.status != 200) {
        return;
      }

      this.moveTargets = r.data.files
    },
    changeMoveDir(folder) {
      if (folder == -1) {
        let parts = this.currentMove.path.split('.')

        this.currentMove.path = parts.slice(0, parts.length - 1).join('.')
        this.currentMove.id = this.lastFolder
        this.currentMove.display_name = 'Top Level'
      }
      else {
        this.lastFolder = this.currentMove.id
        this.currentMove.path = folder.folder
        this.currentMove.id = folder.id
        this.currentMove.display_name = folder.display_name
      }

      this.getMoveDir()
    },
    showItemMove() {
      this.currentMove.path = 'Root'
      this.currentMove.id = null
      this.currentMove.display_name = 'Top Level'
      this.getMoveDir()
      this.$refs.moveItem.showModal()
    },
    showFolderRename() {
      this.newItem = this.activeItem.display_name
      this.$refs.renameFolder.showModal()
    },
    async setItemName() {
      let r = await axios.put(`/api/files/${this.activeItem.id}`, {
        file: {display_name: this.newItem}
      })

      if (r.status != 200) {
        return
      }

      this.activeItem = {}
      this.newItem = ''
      this.getItems()

      this.$refs.renameFile.close()
      this.$refs.renameFolder.close()
    },
    showFileRename() {
      this.newItem = this.activeItem.display_name
      this.$refs.renameFile.showModal()
    },
    async download(item) {
      window.open(`/api/files/download/${item.id}`, '_blank')
    },
    showMenu(menu, event, item) {
      if (this.user && this.user.superuser) {
        this.$refs[menu].style.display = 'flex'
        this.$refs[menu].style.left = event.x + 'px'
        this.$refs[menu].style.top = event.y + 'px'

        this.activeItem = item
      }
    },
    getFileIcon(item) {
      if (/\.pdf$/.test(item.filename.toLowerCase())) {
        return 'pdf-icon.png'
      }

      return 'file-icon.png'
    },
    async getItems() {
      let params = {
        path: this.currentFolder.folder,
        folder_id: this.value.id,
        fields: '~path',
      }

      if (this.sortMethod) {
        params.order = this.sortMethod
      }

      let r = await axios.get('/api/files/get-items', {params})        

      if (r.status != 200) {
        return;
      }

      this.folderItems = r.data.files
    },
    async changeFolder(item) {
      // let nextItem = item.display_name.replace(/[^a-zA-Z0-9_ ]+/g, '')
      // nextItem = `${item.folder}.${nextItem.replace(/ /g, '_')}`

      this.$router.push(`/${item.id}`)
    },
    hideMenus() {
      this.$refs.folderMenu.style.display = "none"
      this.$refs.fileMenu.style.display = "none"

      // if (this.$refs.renameFile.open || this.$refs.renameFolder.open) {
      // this.activeItem = {}
      // }
    },
  },
  mounted() {
    document.addEventListener('click', this.hideMenus)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.hideMenus)
  },
}
</script>

<style lang="scss">
@import '../scss/include-media';
.file-list {
  margin-top: 1.5rem;
  display: flex;
  flex-flow: column wrap;
  align-items: flex-start;
  justify-content: flex-start;
  align-content: flex-start;

  /* height: 360px; */

  /* @supports (display: grid) { */
  /*     height: auto; */
  /*     max-height: 360px; */
  /* } */

  .item {
    margin: 0 1rem;
    box-sizing: border-box;

    border: solid 1px transparent;

    width: 95%;

    a {
      padding: 8px 1rem;
      display: flex;
      flex-flow: row nowrap;
      align-items: center;

      &:hover {
        background: rgba(47, 103, 61, 0.05);
      }


      &.file .name {
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
      }

      .file-date {
        font-size: 85%;
        margin: 0 2rem;
        text-align: right;
        flex: 1 0 auto;
      }

      img {
        width: 24px;
        height: 24px;
        display: inline-block;
        margin: 0 0.5rem 0 0;
      }

      font-size: 0.875rem;
      color: #222;
      text-decoration: none;

      word-wrap: break-word;
      overflow-wrap: break-word;
    }

    &.active {
      border-color: #0d6938;
    }

  }

.context-menu {
  display: none;
  position: fixed;

  flex-flow: column;
  min-width: 12rem;

  background: #fffdf7;
  border: solid black 1px;

  a {
    padding: 8px 16px;
    text-decoration: none;

    &:hover {
      /* background: rgba(0, 0, 0, 0.08); */
      background: rgba(47, 103, 61, 0.05);
    }
  }
}

.move-item-form {
  .move-folder-list {
    border: solid 1px #eaeaea;
    margin-bottom: 1.5rem;
    max-height: 20rem;
    overflow: auto;

    p {
      padding: 1rem;
    }

    .folder {
      user-select: none;

      &:nth-child(odd) {
        background: #f5f5f5;
      }
      a {
        display: block;
        padding: 1rem;

        &:hover {
          /* background: hsl(148, 40%, 96%); */
          background: rgba(47, 103, 61, 0.05);
        }
      }
    }
  }
}

dialog {
  @include media('<tablet') {
    max-width: 99vw;
  }
  @include media('<desktop') {
    max-width: 60vw;
  }
  @include media('>=desktop') {
    max-width: 40vw;
  }
  button {
    padding: 0.5rem 1rem;

    &:first-child {
      margin-right: 1rem;
    }
  }
}

.move-item-dialog {
  width: 100%;
}
}

</style>
